import { faker } from "@faker-js/faker";

import {
  Confidence,
  FindingStatus,
  Mode,
  ScmType,
  Severity,
} from "@protos/common/v1/common";
import { SecretsFinding, ValidationState } from "@protos/secrets/v1/secrets";

export const generateSecretData = (length: number) => {
  const arr: SecretsFinding[] = [];
  // TODO: Move these enums to a common generator service
  const severities = [Severity.HIGH, Severity.LOW, Severity.MEDIUM];
  const modes = [Mode.MONITOR, Mode.COMMENT, Mode.BLOCK];
  const status = [
    FindingStatus.FIXED,
    FindingStatus.OPEN,
    FindingStatus.IGNORED,
  ];
  const validationState = [
    ValidationState.CONFIRMED_INVALID,
    ValidationState.CONFIRMED_VALID,
    ValidationState.NO_VALIDATOR,
    ValidationState.VALIDATION_ERROR,
  ];
  const confidence = [Confidence.HIGH, Confidence.LOW, Confidence.MEDIUM];

  const scmType = [
    ScmType.AZURE_DEVOPS,
    ScmType.BITBUCKET,
    ScmType.GITHUB,
    ScmType.GITLAB,
    ScmType.GITHUB_ENTERPRISE,
    ScmType.GITLAB_SELFMANAGED,
  ];
  for (let i = 0; i < length; i++) {
    arr.push(
      SecretsFinding.create({
        createdAt: faker.date.past(),
        updatedAt: faker.date.past(),
        id: faker.number.int(),
        type: faker.lorem.word(),
        confidence: confidence[faker.number.int({ min: 0, max: 2 })],
        severity: severities[faker.number.int({ min: 0, max: 2 })],
        findingPath: faker.system.filePath(),
        findingPathUrl: faker.internet.url(),
        mode: modes[faker.number.int({ min: 0, max: 2 })],
        ref: faker.lorem.word(),
        refUrl: faker.internet.url(),
        repository: {
          name: faker.lorem.word(),
          url: faker.internet.url(),
          scmType: scmType[faker.number.int({ min: 0, max: 5 })],
        },
        status: status[faker.number.int({ min: 0, max: 2 })],
        validationState: validationState[faker.number.int({ min: 0, max: 3 })],
        ruleHashId: faker.lorem.word(),
      })
    );
  }

  return arr;
};
